// Version : 0.0.2
// Author :
// LastEdit : VISHAL BHARATHI
// Last ADD : UNNECESSARY PARTS REMOVED
// MODIFIED DATE: 19-09-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/******************* FETCH GROUP MEMBER START ******************************** */
export const fetchGroupMember = (fetchData: any) => {
	const data = {
		GetGroupMemberListToken: fetchData,
	};
	const url = `${API_URL}fetchMemberListBasedOnGroup`;
	return makeApiCall(url, data);
};
/******************* FETCH GROUP MEMBER END ******************************** */

/******************* FETCH WALLET REPORT START  ******************************** */
export const fetchWalletReport = (fetchData: any) => {
	const data = {
		GetWalletCollectionReportToken: fetchData,
	};
	const url = `${API_URL}getWalletCollectionReport`;
	return makeApiCall(url, data);
};
/******************* FETCH WALLET REPORT END  ******************************** */
